import { useQuery } from '@tanstack/react-query';
import { api, type AgentProfile } from '@/lib/api';

export function useAgent(name: string) {
  return useQuery({
    queryKey: ['agent', name],
    queryFn: async () => {
      const response = await api.get<AgentProfile>(`/agents/${name}`);

      if (!response.success) {
        throw new Error(response.error?.message || 'Failed to fetch agent');
      }

      return response.data!;
    },
    enabled: !!name,
  });
}
